export enum FlowSections {
  start = 1,
  end = 2,
  inprogress = 3,
  inprogressEnd = 4,
}

export type FlowSectionType = keyof typeof FlowSections;
